import ApiCallManager from '../models/apiCallManager';
import Campaign from '../models/campaign';

/**
 * @ngdoc service
 * @name campaignsService
 * @description
 * This service is meant to fetch all the campaigns and its media.
 *
 * @memberof common
 */
class CampaignsService extends ApiCallManager {
  /**
   * Class constructor.
   * @param {Service} appUtils             The service to get the page query param.
   * @param {Service} contentCreatorAppAPI The service to fetch the customer campaigns.
   * @ignore
   */
  constructor(appUtils, contentCreatorAppAPI) {
    'ngInject';

    super(
      appUtils,
      (content) => content.map((campaign) => new Campaign(
        appUtils,
        campaign,
        contentCreatorAppAPI,
      )),
      contentCreatorAppAPI.getCampaigns.bind(contentCreatorAppAPI),
    );
  }
  /**
   * Get the Campaigns list from the BE.
   * @param {Boolean} refresh flag to force a refresh of the Campaigns.
   * @return {Promise}
   */
  getCampaigns(refresh) {
    return this._getContent(refresh);
  }
  /**
   * Get a Campaign by its Id.
   * @return {Promise}
   */
  getCampaignById(campaignId) {
    return this._getContentById(campaignId);
  }
}

export default CampaignsService;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/services/campaigns.js